import { useMatches } from 'react-router-dom';

/**
 * Retrieve specified properties defined in the handles of the current routes
 * @typeparam T - The shape of the properties to extract from route handles
 * @returns An object containing the first occurrence of each property from route handles
 */
export const useRouteHandles = <T extends object>() => {
  const matches = useMatches();
  const result = {} as Partial<T>;

  // Loop through matches in reverse to give priority to the more specific routes
  for (let i = matches.length - 1; i >= 0; i--) {
    const { handle } = matches[i];

    if (handle) {
      Object.keys(handle).forEach((key) => {
        // We already found a match in a previous route, skip this one
        if (key in result) {
          return;
        }

        result[key as keyof T] = handle[key] as T[keyof T];
      });
    }
  }

  return result;
};
